import _ from 'lodash'

import { useState, useEffect, useRef } from '@wordpress/element'
import apiFetch from '@wordpress/api-fetch'

import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Spinner from 'react-bootstrap/Spinner'
import Badge from 'react-bootstrap/Badge'
import CloseButton from 'react-bootstrap/CloseButton'

import Table from 'react-bootstrap/Table'

import Award from './icons/Award.jsx'


// import 'bootstrap/dist/css/bootstrap.min.css'
import './index.scss'

function WinnersTable(props) {
	const { attributes } = props
	const [settings, setSettings] = useState(false)
	const [entries, setEntries] = useState([])
	const [showFilters, setShowFilters] = useState(false)
	const [more, setMore] = useState(true)
	const [loading, setLoading] = useState(false)
	const [args, setArgs] = useState(_.get(attributes, 'args', {}))

	const productCategoryRef = useRef()
	const priceCategoryRef = useRef()
	const awardRef = useRef()
	const yearRef = useRef()

	useEffect(() => {
		if (props.settings) {
			setSettings(props.settings)
		} else {
			apiFetch({ path: '/bw-winners/v1/block-settings' }).then((settings) => {
				setSettings(settings)
			})
		}
		searchEntries()
	}, [])

	useEffect(() => {
		if (!loading && more) {
			moreEntries()
		}
	}, [loading, more])

	const showSearch = !attributes.hideSearch
	const allSites = !!attributes.allSites

	const orderByOptions = [
		{
			label: 'Brand Name',
			value: 'brand_name'
		},
		{
			label: 'Product Name',
			value: 'product_name'
		},
		{
			value: 'product_type',
			label: 'Product Type'
		},
		{
			label: 'Product Price Category',
			value: 'product_price'
		},
		{
			label: 'Entry Year',
			value: 'entry_year'
		},
		{
			label: 'Entry Score',
			value: 'entry_score'
		}
	]
	const orderOptions = [
		{
			label: 'Ascending',
			value: 'ASC'
		},
		{
			label: 'Descending',
			value: 'DESC'
		}
	]


	const getEntries = async (nextArgs) => {
		const data = await apiFetch({
			path: allSites ? '/bw-winners/v1/block-data-all-sites' : '/bw-winners/v1/block-data',
			method: 'POST',
			data: nextArgs
		})
		_.each(data.entries, (entry) => {
			entry.categories = _.join(_.map(entry['product_category'], 'name'), ', ')

			entry.brand = entry['brand_url'] ? (
				<a
					href={formatUrl(entry['brand_url'])}
					target="blank"
					rel="noopener"
				>
					{entry['brand_name']}
				</a>
			) : entry['brand_name']

			entry.product = entry['post_product_status'] === 'publish' ? (
				<a href={formatUrl(entry['post_product_url'])} >{entry['product_name']}</a>
			) : entry['product_name']
		})
		if (nextArgs.page === 1) {
			setEntries(data.entries)
		} else {
			const nextEntries = [...entries, ...data.entries]
			setEntries(nextEntries)
		}
		setArgs(nextArgs)
		setMore(!!data.totalPages && nextArgs.page < data.totalPages);
		setLoading(false)
	}

	const searchEntries = () => {
		if (loading) return
		setLoading(true)
		const requestArgs = args ? _.clone(args) : _.get(attributes, 'args', {})
		requestArgs.page = 1
		getEntries(requestArgs)
	}
	const moreEntries = () => {
		if (!more || loading) return
		setLoading(true)
		const requestArgs = args ? _.clone(args) : _.get(attributes, 'args', {})
		requestArgs.page = _.get(requestArgs, 'page', 0) + 1
		getEntries(requestArgs)
	}

	const blockId = _.get(attributes, 'blockId', '')

	const awardLabels = {
		'doubleGold': 'Double Gold',
		'gold': 'Gold',
		'silver': 'Silver',
		'bronze': 'Bronze'
	}
	const getAward = (score) => {
		const scoreAs = _.get(settings, ['settings', 'displayScoreAs']);
		if (score >= _.get(scoreAs, ['doubleGold'])) {
			return (
				<i style={{ display: 'flex', justifyContent: 'space-around' }}>
					<Award
						style={{ height: '2em', transform: 'translate(85%, 0)' }}
						score=""
					/>
					<Award
						style={{ height: '2em', transform: 'translate(-85%, 0)' }}
						score={score}
					/>
				</i>
			)
		} else if (score >= _.get(scoreAs, ['gold'])) {
			return (
				<i style={{ display: 'flex', justifyContent: 'space-around' }}>
					<Award
						style={{ height: '2em' }}
						score={score}
					/>
				</i>
			)
		} else if (score >= _.get(scoreAs, ['silver'])) {
			return (
				<i style={{ display: 'flex', justifyContent: 'space-around' }}>
					<Award
						color1="#ccc"
						color2="#999"
						color3="#666"
						style={{ height: '2em' }}
						score={score}
					/>
				</i>
			)
		} else if (score >= _.get(scoreAs, ['bronze'])) {
			return (
				<i style={{ display: 'flex', justifyContent: 'space-around' }}>
					<Award
						color1="#b74"
						color2="#842"
						color3="#542"
						style={{ height: '2em' }}
						score={score}
					/>
				</i>
			)
		}
		return ''
	}

	const handleSearchChange = (event) => {
		const nextArgs = _.clone(args)
		_.set(nextArgs, 's', _.trim(event.target.value))
		setArgs(nextArgs)
	}

	const filterOptions = (filter) => {
		return _.difference(
			_.get(settings, ['filterSuggestions', filter], []),
			_.get(args, ['filters', filter], []),
		);
	}

	const handleAddFilter = (filter, ref) => () => {
		const nextArgs = _.clone(args)
		_.set(
			nextArgs,
			['filters', filter],
			_.uniq([..._.get(nextArgs, ['filters', filter], []), ref.current.value])
		)
		setArgs(nextArgs)
	}
	const handleRemoveFilter = (filter, item) => () => {
		const nextArgs = _.clone(args)
		_.set(
			nextArgs,
			['filters', filter],
			_.difference(
				_.get(nextArgs, ['filters', filter], []),
				[item]
			)
		)
		setArgs(nextArgs)
	}

	const handleShowFilters = (event) => {
		setShowFilters(!showFilters)
	}
	const handleOrderByChange = (event) => {
		const nextArgs = _.clone(args)
		_.set(nextArgs, 'sort_dir', event.target.value)
		setArgs(nextArgs)
	}
	const handleOrderChange = (event) => {
		const nextArgs = _.clone(args)
		_.set(nextArgs, 'sort_field', event.target.value)
		setArgs(nextArgs)
	}
	const formatUrl = (url) => {
		if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
			return '//' +_.trimStart(url, '/');
		}
		return url;
	}

	const productCategoryOptions = filterOptions('product_category')
	const priceCategoryOptions = filterOptions('price_category')
	const awardOptions = filterOptions('award')
	const yearOptions = filterOptions('year')

	const productCategoryFilters = _.get(args, ['filters', 'product_category'], [])
	const priceCategoryFilters = _.get(args, ['filters', 'price_category'], [])
	const awardFilters = _.get(args, ['filters', 'award'], [])
	const yearFilters = _.get(args, ['filters', 'year'], [])

	return (
		<div id={attributes.blockId} className="bw-winners-table">
			{showSearch && (
				<Container fluid>
					<Row>
						<Col xs={12} md={true}>
							<Form.Control
								size="lg"
								type="text"
								placeholder="Search by keyword..."
								onChange={handleSearchChange}
							/>
						</Col>
						<Col xs={12} md="auto">
							{loading ? (
								<Button
									variant="primary"
									size="lg"
								>
									<Spinner
										as="span"
										animation="grow"
										size="sm"
										role="status"
										disabled
									/> Search
								</Button>
							) : (
								<Button variant="primary" onClick={searchEntries} size="lg">Search</Button>
							)}
						</Col>
						<Col xs={12} md="auto">
							<Button
								variant="secondary"
								size="lg"
								onClick={handleShowFilters}
							>Advanced Filters</Button>
						</Col>
					</Row>
					{showFilters ? (
						<Row>
							<Col>
								{!_.isEmpty(_.get(settings, ['filterSuggestions', 'product_category'])) && (
									<Form.Group className="my-3" controlId={blockId + '-product-category'}>
										<Form.Label>Product Category:</Form.Label>
										{!_.isEmpty(productCategoryOptions) && (
											<Row>
												<Col xs={12} md={true}>
													<Form.Select
														size="lg"
														ref={productCategoryRef}
													>
														{_.map(productCategoryOptions, (option) => (
															<option value={option}>{option}</option>
														))}
													</Form.Select>
												</Col>
												<Col xs={12} md="auto">
													<Button variant="primary" size="lg" onClick={handleAddFilter('product_category', productCategoryRef)}>Add</Button>
												</Col>
											</Row>
										)}
										{!_.isEmpty(productCategoryFilters) && (
											<div
												className="mt-3"
												style={{
													display: 'flex',
													flexWrap: 'wrap',
													gap: '0.5em'
												}}
											>
												{_.map(productCategoryFilters, (item) => (
													<Badge
														style={{
															display: 'inline-flex',
															alignItems: 'center',
															gap: '0.5em'
														}}
														pill
														bg="secondary"
													>
														{item}
														<CloseButton
															style={{
																height: '0.5em',
																width: '0.5em'
															}}
															variant="white"
															onClick={handleRemoveFilter('product_category', item)}
														/>
													</Badge>
												))}
											</div>
										)}
									</Form.Group>
								)}
								{!_.isEmpty(_.get(settings, ['filterSuggestions', 'price_category'])) && (
									<Form.Group className="my-3" controlId={blockId + '-price-category'}>
										<Form.Label>Price Category:</Form.Label>
										{!_.isEmpty(priceCategoryOptions) && (
											<Row>
												<Col xs={12} md={true}>
													<Form.Select
														size="lg"
														ref={priceCategoryRef}
													>
														{_.map(priceCategoryOptions, (option) => (
															<option value={option}>{option}</option>
														))}
													</Form.Select>
												</Col>
												<Col xs={12} md="auto">
													<Button variant="primary" size="lg" onClick={handleAddFilter('price_category', priceCategoryRef)}>Add</Button>
												</Col>
											</Row>
										)}
										{!_.isEmpty(priceCategoryFilters) && (
											<div
												className="mt-3"
												style={{
													display: 'flex',
													flexWrap: 'wrap',
													gap: '0.5em'
												}}
											>
												{_.map(priceCategoryFilters, (item) => (
													<Badge
														style={{
															display: 'inline-flex',
															alignItems: 'center',
															gap: '0.5em'
														}}
														pill
														bg="secondary"
													>
														{item}
														<CloseButton
															style={{
																height: '0.5em',
																width: '0.5em'
															}}
															variant="white"
															onClick={handleRemoveFilter('price_category', item)}
														/>
													</Badge>
												))}
											</div>
										)}
									</Form.Group>
								)}
								{!_.isEmpty(_.get(settings, ['filterSuggestions', 'award'])) && (
									<Form.Group className="my-3" controlId={blockId + '-award'}>
										<Form.Label>Award</Form.Label>
										{!_.isEmpty(awardOptions) && (
											<Row>
												<Col xs={12} md={true}>
													<Form.Select
														size="lg"
														ref={awardRef}
													>
														{_.map(awardOptions, (option) => (
															<option value={option}>{_.get(awardLabels, option)}</option>
														))}
													</Form.Select>
												</Col>
												<Col xs={12} md="auto">
													<Button variant="primary" size="lg" onClick={handleAddFilter('award', awardRef)}>Add</Button>
												</Col>
											</Row>
										)}
										{!_.isEmpty(awardFilters) && (
											<div
												className="mt-3"
												style={{
													display: 'flex',
													flexWrap: 'wrap',
													gap: '0.5em'
												}}
											>
												{_.map(awardFilters, (item) => (
													<Badge
														style={{
															display: 'inline-flex',
															alignItems: 'center',
															gap: '0.5em'
														}}
														pill
														bg="secondary"
													>
														{_.get(awardLabels, item)}
														<CloseButton
															style={{
																height: '0.5em',
																width: '0.5em'
															}}
															variant="white"
															onClick={handleRemoveFilter('award', item)}
														/>
													</Badge>
												))}
											</div>
										)}
									</Form.Group>
								)}
								{!_.isEmpty(_.get(settings, ['filterSuggestions', 'year'])) && (
									<Form.Group className="my-3" controlId={blockId + '-year'}>
										<Form.Label>Year</Form.Label>
										{!_.isEmpty(yearOptions) && (
											<Row>
												<Col xs={12} md={true}>
													<Form.Select
														size="lg"
														ref={yearRef}
													>
														{_.map(yearOptions, (option) => (
															<option value={option}>{option}</option>
														))}
													</Form.Select>
												</Col>
												<Col xs={12} md="auto">
													<Button variant="primary" size="lg" onClick={handleAddFilter('year', yearRef)}>Add</Button>
												</Col>
											</Row>
										)}
										{!_.isEmpty(yearFilters) && (
											<div
												className="mt-3"
												style={{
													display: 'flex',
													flexWrap: 'wrap',
													gap: '0.5em'
												}}
											>
												{_.map(yearFilters, (item) => (
													<Badge
														style={{
															display: 'inline-flex',
															alignItems: 'center',
															gap: '0.5em'
														}}
														pill
														bg="secondary"
													>
														{item}
														<CloseButton
															style={{
																height: '0.5em',
																width: '0.5em'
															}}
															variant="white"
															onClick={handleRemoveFilter('year', item)}
														/>
													</Badge>
												))}
											</div>
										)}
									</Form.Group>
								)}
								<Row>
									<Col xs={12} md={true}>
										<Form.Group className="my-3" controlId={blockId + '-sortby'}>
											<Form.Label>Order Results By</Form.Label>
											{!_.isEmpty(orderByOptions) && (
												<Form.Select
													size="lg"
													value={_.get(args, 'sort_field')}
													onChange={handleOrderChange}
												>
													{_.map(orderByOptions, ({ label, value }) => (
														<option value={value}>{label}</option>
													))}
												</Form.Select>
											)}
										</Form.Group>
									</Col>
									<Col xs={12} md={true}>
										<Form.Group className="my-3" controlId={blockId + '-order'}>
											<Form.Label>Order</Form.Label>
											{!_.isEmpty(orderOptions) && (
												<Form.Select
													size="lg"
													value={_.get(args, 'sort_dir')}
													onChange={handleOrderByChange}
												>
													{_.map(orderOptions, ({ label, value }) => (
														<option value={value}>{label}</option>
													))}
												</Form.Select>
											)}
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col style={{ textAlign: 'right' }}>
										{loading ? (
											<Button
												variant="primary"
												size="lg"
											>
												<Spinner
													as="span"
													animation="grow"
													size="sm"
													role="status"
													disabled
												/> Advanced Search
											</Button>
										) : (
											<Button variant="primary" size="lg" onClick={searchEntries}>Advanced Search</Button>
										)}
									</Col>
								</Row>
							</Col>
						</Row>
					) : ''}
				</Container>
			)}
			<Container fluid className="my-3">
				<Row>
					<Col>
						<Table
							responsive
							striped
							bordered
							style={{
								opacity: loading ? 0.6 : 1
							}}
						>
							<thead>
								<tr>
									{ allSites && (
										<th>Site</th>
									) }
									<th>Brand Name</th>
									<th>Product Type</th>
									<th>Product Name</th>
									<th>Product Categories</th>
									<th>Price Category</th>
									<th>Entry Year</th>
									<th>Entry Award</th>
								</tr>
							</thead>
							<tbody>
								{_.map(entries, entry =>
									<tr key={entry['entry_id']}>
										{ allSites && (
											<td style={{ verticalAlign: 'middle' }}>
												<a href={`${location.protocol}//${_.get(entry, 'domain', '')}`} target="_blank">
													{_.get(entry, 'blogname', '')}
												</a>
											</td>
										) }
										<td style={{ verticalAlign: 'middle' }}>{_.get(entry, 'brand', '')}</td>
										<td style={{ verticalAlign: 'middle' }}>{_.get(entry, 'product_type', '')}</td>
										<td style={{ verticalAlign: 'middle' }}>{_.get(entry, 'product', '')}</td>
										<td style={{ verticalAlign: 'middle' }}>{_.get(entry, 'categories', '')}</td>
										<td style={{ verticalAlign: 'middle' }}>{_.get(entry, 'product_price', '')}</td>
										<td style={{ verticalAlign: 'middle' }}>{_.get(entry, 'entry_year', '')}</td>
										<td style={{ verticalAlign: 'middle' }}>{getAward(_.parseInt(entry['entry_score']))}</td>
									</tr>
								)}
							</tbody>
						</Table>
					</Col>
				</Row>
				<Row className="my-3">
					<Col>
						{more && (
							loading ? (
								<Button
									variant="primary"
									size="lg"
								>
									<Spinner
										as="span"
										animation="grow"
										size="sm"
										role="status"
										disabled
									/> Show More
								</Button>
							) : (
								<Button variant="primary" size="lg" onClick={moreEntries}>Show More</Button>
							)
						)}
					</Col>
				</Row>
			</Container>
		</div>
	)
}
export default WinnersTable
